import Swiper from '../vendors/swiper.min.js';

const selectors = {
  carousel: '[data-carousel]',
  carouselArrowLeft: '[data-arrow-left]',
  carouselArrowRight: '[data-arrow-right]',
  carouselContainer: '[data-carousel-container]',
  carouselScrollbar: '[data-scrollbar]',
  carouselSlide: '.swiper-slide',
  productUpsell: '[data-product-upsell]',
  upsellSwatch: '[data-product-swatch]',
};

const dom = {};

const cacheDom = () => {
  dom.productUpsell = document.querySelectorAll(selectors.productUpsell);
};

const initCarousel = (thisProductUpsell, carouselContainer, carouselSlides) => {
  const carouselScrollbar = thisProductUpsell.querySelector(
    selectors.carouselScrollbar,
  );
  const carouselArrowRight = thisProductUpsell.querySelector(
    selectors.carouselArrowRight,
  );
  const carouselArrowLeft = thisProductUpsell.querySelector(
    selectors.carouselArrowLeft,
  );
  const carouselSlidesLength = carouselSlides.length;

  let slidesToShow = '';
  let slideOffset = '';
  let slidesToShowTablet = '';
  let slideOffsetTablet = '';
  let slidesToShowMobile = 2.3;
  let slideOffsetMobile = 24;

  if (carouselSlidesLength > 4) {
    slidesToShow = 4.4;
    slideOffset = 48;
  } else {
    slidesToShow = 4;
    slideOffset = 0;
  }

  if (carouselSlidesLength > 3) {
    slidesToShowTablet = 3.4;
    slideOffsetTablet = 48;
  } else {
    slidesToShowTablet = 3;
    slideOffsetTablet = 0;
  }

  if (carouselSlidesLength <= 2) {
    slidesToShowMobile = 2;
    slideOffsetMobile = 0;
  }

  const swiper = new Swiper(carouselContainer, {
    breakpoints: {
      1024: {
        centerInsufficientSlides: true,
        slidesOffsetAfter: slideOffset,
        slidesOffsetBefore: slideOffset,
        slidesPerView: slidesToShow,
        spaceBetween: 32,
      },
      1441: {
        centerInsufficientSlides: true,
        slidesOffsetAfter: slideOffset,
        slidesOffsetBefore: slideOffset,
        slidesPerView: slidesToShow,
        spaceBetween: 32,
      },
      752: {
        centerInsufficientSlides: true,
        slidesOffsetAfter: slideOffsetTablet,
        slidesOffsetBefore: slideOffsetTablet,
        slidesPerView: slidesToShowTablet,
        spaceBetween: 32,
      },
    },
    freeMode: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true,
    },
    navigation: {
      nextEl: carouselArrowRight,
      prevEl: carouselArrowLeft,
    },
    scrollbar: {
      draggable: true,
      el: carouselScrollbar,
    },
    slidesOffsetAfter: slideOffsetMobile,
    slidesOffsetBefore: slideOffsetMobile,
    slidesPerView: slidesToShowMobile,
    spaceBetween: 12,
  });
};

const variantChange = (swatch, swatches) => {
  if (!swatch.classList.contains('unavailable')) {
    const slide = swatch.closest(selectors.carouselSlide);
    const slideImage = slide.querySelector('.tile-image--primary');
    const swatchImage = swatch.querySelector('span').dataset.img;

    slideImage.src = swatchImage;

    swatches.forEach((swatch) => {
      swatch.classList.remove('active');
    });

    swatch.classList.add('active');
  }
};

const handleBadgingEvents = () => {
  if (dom.productUpsell) {
    dom.productUpsell.forEach((productUpsell) => {
      const thisProductUpsell = productUpsell;
      const carouselContainer = thisProductUpsell.querySelector(
        selectors.carouselContainer,
      );
      const carouselSlides = carouselContainer.querySelectorAll(
        selectors.carouselSlide,
      );
      const swatches = productUpsell.querySelectorAll(selectors.upsellSwatch);

      initCarousel(thisProductUpsell, carouselContainer, carouselSlides);

      swatches.forEach((swatch) => {
        swatch.addEventListener('click', (event) => {
          variantChange(swatch, swatches);
        });
      });
    });
  }
};

const featureBlogSection = {
  init() {
    cacheDom();
    handleBadgingEvents();
  },
};

export default featureBlogSection;
